import React, { useState, useRef } from "react";
import { Typography } from "@mui/material";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import * as api from "../../../actions/api";
import DispenserFormData from "./LabTestEntryItems.js";
import { useTranslation } from "react-i18next";

import { format } from 'date-fns';
const EditLabTestEntry = (props) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey =
    "entry-of-the-results-of-the-various-assessments-for-the-patients";
  const FacilityId = localStorage.getItem("FacilityId");

  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState({
    TransactionDate: "",
    TransactionNo: "",
    FacilityId: FacilityId,
    TransactionTypeId: 999,
    PatientId: "",
    idNumber: "",
    PatientFirstName: "",
    PatientLastName: "",
    ContactNumber: "",
    GenderTypeId: "",
    Dob: "",
    TestToFacilityId: "",
    PreparedBy: "",
    ApprovedBy: "",
    Remarks: "",
    bStockUpdated: 0,
    ItemGroupId: "",
  });
  const [selectedDate, setSelectedDate] = useState(
    // new Date()
    format(new Date(), 'yyyy-MM-dd')
  );
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const [ManyTableData, setManyTableData] = useState([]);
  const [bStockUpdate, setbStockUpdate] = useState("0");
  const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);
  const [TransactionId, setTransactionId] = useState("0");
  const [deletedDataSet, setDeletedDataSet] = useState([]);

  const [StockPost, setStockPost] = useState(false);

  const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState("");

  const [bFirst, setBFirst] = useState(true);

  const saveInFlightRef = useRef(false);

  const handleRDateChange = (date, field) => {
    let newDate;
    if (date == null) {
      newDate = date;
    } else {
      newDate = format(new Date(date), 'yyyy-MM-dd');
    }

    setFormData({ ...formData, [field]: newDate });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  const { data, refetch } = useQuery(
    ["entry-of-the-results-of-the-various-assessments-for-the-patients", id],
    () =>
      api.getLabTestEntryInv(id).then((res) => {
        //This is for user has VIEW/EDIT permission in this page start
        if (props.permissionType === 1) {
          //when permissionType then it is only VIEW permission otherwise normal permission
          res.data.bStockUpdated = 1;
        }
        //This is for user has VIEW/EDIT permission in this page end

        setTransactionId(id);
        setFormData(res.data);
        setbStockUpdate(res.data.bStockUpdated);
        setManyTableData(res.data.ManyJsonSave); //res.data.ManyJsonSave
        setUpdatedDetailGridData(res.data.ManyJsonSave);
        setGeneratedInvoiceNo(res.data.TransactionNo);
        setDeletedDataSet([]);
        setBFirst(true);

        return res.data;
      }),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(id),
    }
  );

  const { isLoading: isUpdateMutating, mutate: mutateUpdate } = useMutation(
    api.updateLabTestEntryInv,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          setbStockUpdate(data.bStockUpdated);
          if (data.bStockUpdated == 1) {
            mutatePost(TransactionId);
          } else {
            refetch();

            props.openNoticeModal({
              isOpen: true,
              msg: data.message,
              msgtype: data.success,
            });

            //swal("Success!", "", "success");
          }
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: data.success,
          });
        }
      },
    }
  );

  const { isLoading: isPostMutating, mutate: mutatePost } = useMutation(
    api.updateTestAppointmentStatus,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          setbStockUpdate(1);
          setDeletedDataSet([]);

          if (data.data.success == 0) {
            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });

            // swal(data.data.message, "", "warning");
          } else {
            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });
            refetch();

            //swal(data.data.message, "", "success");
          }
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        }
      },
    }
  );

  const isSubmitting = isUpdateMutating || isPostMutating;

  const runLabTestEntryUpdate = (payload) => {
    if (saveInFlightRef.current || isPostMutating) return;
    saveInFlightRef.current = true;
    mutateUpdate(payload, {
      onSettled: () => {
        saveInFlightRef.current = false;
      },
    });
  };

  const handleAdd = (NonOrderProductData) => {
    setManyTableData(NonOrderProductData);
    setUpdatedDetailGridData(NonOrderProductData);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
    data[name] = value;
    setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      TransactionDate: "",
      TransactionNo: "",
      FacilityId: FacilityId,
      TransactionTypeId: 999,
      PatientId: "",
      idNumber: "",
      PatientFirstName: "",
      PatientLastName: "",
      ContactNumber: "",
      GenderTypeId: "",
      Dob: "",
      TestToFacilityId: "",
      PreparedBy: "",
      ApprovedBy: "",
      Remarks: "",
      bStockUpdated: 0,
      ItemGroupId: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = [
      "TransactionDate",
      "TransactionNo",
      "TestToFacilityId",
      "PreparedBy",
      "GenderTypeId",
      "Dob",
    ];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const deleteReceiveInv = (data) => {

    let newarray = ManyTableData.filter((element) => element !== data);

    setManyTableData(newarray);
    setUpdatedDetailGridData(newarray);
    if (data.TransactionItemId != null) {
      let newDeletedDataSet = [data.TransactionItemId];
      setDeletedDataSet(newDeletedDataSet.concat(deletedDataSet));
    }
  };

  const handleUpdate = async (e) => {
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        ManyJsonSave: ManyTableData,
        deletedDataSet: deletedDataSet,
      };
      runLabTestEntryUpdate(fDtat);
    }
  };

  const handlePost = async (e) => {
    if (saveInFlightRef.current || isSubmitting) return;

    const hasNullOrEmptyResults = ManyTableData.some(item => item.Results === null || item.Results === '');
    
    if (hasNullOrEmptyResults) {
        props.openNoticeModal({
            isOpen: true,
            msg:  t(DispensingLanguage[lan][menukey]["Test result can not be blank"]),
            msgtype: 0,
        });
        return;
    }
    
    if (validateForm(formData)) {
    
      
      swal({
        title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
        text: t(DispensingLanguage[lan][menukey]["Do you really want to post the appointment test?"]),
        icon: "warning",
        buttons: [t(DispensingLanguage[lan][menukey]["No"]), 
        t(DispensingLanguage[lan][menukey]["Yes"])],
        dangerMode: true,
      }).then((willAction) => {
        if (willAction) {
          if (saveInFlightRef.current || isSubmitting) return;
          let fDtat={...formData,'ManyJsonSave':ManyTableData,"bStockUpdated":1,'deletedDataSet':deletedDataSet};
          runLabTestEntryUpdate(fDtat); 
          
        }else{
          setbStockUpdate(0);
          let route = `${TransactionId}`;
          props.history.push(route);
        }
      });  
      // End Post Alert

      
    }
     
  };

  const setUpdatedDetailsGridDataHandler = (rows) => {
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        ManyJsonSave: rows,
        deletedDataSet: deletedDataSet,
      };
      runLabTestEntryUpdate(fDtat);
    }

    setManyTableData(rows);
  };

  const handleChangeissuedToFacilityProps = (e) => {
    if (e !== "null") {
      setErrorObject({ ...errorObject, ["IssuedToFacility"]: null });
    }
  };

  // useEffect(() => {

  // }, []);

  const handleAddPatient = (PatientData) => {
    let fdata = { ...formData };
    let row = PatientData;

    fdata["PatientId"] = row[0].PatientId;
    fdata["idNumber"] = row[0].idNumber;
    fdata["PatientLastName"] = row[0].lastName;
    fdata["PatientFirstName"] = row[0].firstName;
    fdata["ContactNumber"] = row[0].contactNumber;
    fdata["Dob"] = row[0].dob;
    fdata["GenderTypeId"] = row[0].GenderTypeId;

    setFormData(fdata);
  };

  return (
    <>
      <DispenserFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        ManyTableData={updatedDetailGridData}
        handleRDateChange={handleRDateChange}
        handleChangeissuedToFacilityProps={handleChangeissuedToFacilityProps}
        selectedDate={selectedDate}
        handleAdd={handleAdd}
        bStockUpdate={bStockUpdate}
        setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
        handlePost={handlePost}
        deleteReceiveInv={deleteReceiveInv}
        handleAddPatient={handleAddPatient}
        generatedInvoiceNo={generatedInvoiceNo}
        bFirst={bFirst}
        {...props}
        isSubmitting={isSubmitting}
      />
    </>
  );
};

export default EditLabTestEntry;
